import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores';
import styles from './Main.module.css';

import { ROUTES } from '@/constants/routes';

export function Main() {
  const location = useLocation();
  const { getUser } = useAuthStore();

  // Only show the landing page on the exact root URL
  const isLandingPage = location.pathname === '/';

  // Redirect logic for root path
  if (isLandingPage) {
    const user = getUser();
    if (user?.is_staff) {
      return <Navigate to={ROUTES.dashboard} replace />;
    }
    return <Navigate to={ROUTES.home} replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <Outlet />
      </div>
    </div>
  );
}
